import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import VersalDHU_ISO from '../../../Image/VersalDHU_ISO.png';

const BntVersalDhpu = () => {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const InfoBox = ({ title, children }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          bgcolor: '#A0C8DF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1.5,
          flexShrink: 0, // mantém o ícone alinhado
        }}
      >
        <CheckCircleIcon sx={{ color: '#F47921', fontSize: 20 }} />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', mb: 1 }}>{title}</Typography>
        <Typography sx={{ ml: 0 }}>{children}</Typography>
      </Box>
    </Box>
  );

  return (
    <div>
      <Button
        size="small"
        onClick={handleClickOpen}
        sx={{
          textTransform: 'none',
          color: '#2b8cb9',
          width: '15%',
          height: '15%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <InfoIcon />
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        sx={{ '& .MuiDialog-paper': { width: '100%' } }}
      >
        <DialogTitle
          sx={{
            fontWeight: 'bold',
            fontFamily: 'Open Sans',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            fontSize: '24px',
          }}
        >
          Versal Data Handling Computer
        </DialogTitle>

        <DialogContent
          sx={{
            padding: 3,
            overflowY: 'auto',
            maxHeight: '70vh',
          }}
        >
          {/* Imagem centralizada */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
            <img
              src={VersalDHU_ISO}
              alt="Versal Data Handling Computer"
              style={{ width: '60%', height: '60%' }}
            />
          </Box>

          {/* Grid com 2 colunas alinhadas */}
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <InfoBox title="Processing Power">
                • Dual-core Arm® Cortex®-A72 <br />
                • Dual-core Arm® Cortex®-R5F <br />
                • Programmable 329K System Logic Cells
              </InfoBox>

              <InfoBox title="Memory">
                • 4GB DDR4 (32 bit) <br />
                • 128MB NOR Flash for Boot
              </InfoBox>

              <InfoBox title="Data Rate Budgets">
                • Space Wire up to 100 Mbps <br />
                • Space Fiber up to 6.25 Gbit/s (3.125 Gbit/s on front connector) <br />
                • 1Mbps CAN
              </InfoBox>
              <InfoBox title="Power Budgets">
                • Input Voltage: 12V <br />
                • Maximum Consumption: 10W
              </InfoBox>
            </Grid>

            <Grid item xs={6}>
              <InfoBox title="Front Panel Interfaces">
                • 1x Gigabit Ethernet <br />
                • 1x Single Lane Space Fibre eSATA connector <br />
                • 2x RS-422 UART <br />
                • 1x JTAG <br />
                • 2x CAN
              </InfoBox>

              <InfoBox title="Mechanical Budgets">
                • Size: 238.75mm x 112mm x 30.48mm <br />
                • Mass: 350 grams <br />
                • Thermal: Δt 15,42°C at the processor junction
              </InfoBox>

              <InfoBox title="Back Plane Interfaces">
                • 4x Space Wire <br />
                • 2x Space Fibre Dual Lane <br />
                • ADHA Standard P2 <br />
                • ADHA Standard P1 with CAN, I2C, Sync and GPIOs <br />
                • ADHA Backplane module with PSON, RST, HMS and Sync signals
              </InfoBox>

            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BntVersalDhpu;
